import type { MenuSnapshot } from '../../types'

const prefix = 'menu-draft-recovery:'
export interface DraftRecovery {
  base: MenuSnapshot
  snapshot: MenuSnapshot
  savedAt: number
}
export function recoveryKey(restaurantId: number): string {
  let session = sessionStorage.getItem(prefix + 'tab')
  if (!session) {
    session = crypto.randomUUID()
    sessionStorage.setItem(prefix + 'tab', session)
  }
  return `${prefix}${restaurantId}:${session}`
}
export function readRecovery(key: string): DraftRecovery | null {
  try {
    const parsed = JSON.parse(localStorage.getItem(key) ?? 'null') as DraftRecovery | null
    if (!parsed || !Array.isArray(parsed.base.categories) || !Array.isArray(parsed.base.items) ||
      !Array.isArray(parsed.snapshot.categories) || !Array.isArray(parsed.snapshot.items)) return null
    return parsed
  } catch { return null }
}
export function writeRecovery(key: string, value: DraftRecovery | null): boolean {
  try {
    if (value) localStorage.setItem(key, JSON.stringify(value))
    else localStorage.removeItem(key)
    return true
  } catch { return false }
}
export function otherRecoveries(restaurantId: number, ownKey: string): string[] {
  try {
    return Object.keys(localStorage).filter(key =>
      key.startsWith(`${prefix}${restaurantId}:`) && key !== ownKey && readRecovery(key) !== null)
  } catch { return [] }
}
export function clearDraftRecoveries(): void {
  try {
    Object.keys(localStorage).filter(key => key.startsWith(prefix)).forEach(key => localStorage.removeItem(key))
  } catch { /* Storage can be disabled. */ }
}
